import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { IFilterTipoEmpleadoModel } from 'src/app/models/interfaces/tipo-empleado/IFilterTipoEmpleadoModel';
import { ITipoEmpleadoModel } from 'src/app/models/interfaces/tipo-empleado/ITipoEmpleadoModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { FilterTipoEmpleadoModel } from 'src/app/models/tipo-empleado/FilterTipoEmpleadoModel';
import { TipoEmpleadoModel } from 'src/app/models/tipo-empleado/TipoEmpleadoModel';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { TipoEmpleadoService } from 'src/app/services/tipo-empleado/tipo-empleado.service';

@Component({
  templateUrl: './configuracion-tipo-empleado-listar.component.html',
  styleUrls: ['./configuracion-tipo-empleado-listar.component.css']
})
export class ConfiguracionTipoEmpleadoListarComponent implements OnInit {
  model!: SearchResultModel<ITipoEmpleadoModel[]>;
  filter: IFilterTipoEmpleadoModel = new FilterTipoEmpleadoModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();
  resultsLength = 0;
  currentPage = 0;

  displayedColumns: string[] = [
    'id',
    'nombre',
    'estado',
    'acciones'
  ];
  
  @ViewChild('paginator') paginator!: MatPaginator;

  constructor(
    private serviceTipoEmpleado: TipoEmpleadoService,
    private serviceParametros: ParametroService
  ) { 
    this.model = new SearchResultModel<ITipoEmpleadoModel[]>(false, new Array<TipoEmpleadoModel>(), 0, 1, 0);
  }

  ngOnInit(): void {
    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_MAESTRO).subscribe((data) => {
      this.listaEstados = data.items;
    });
    
    this.serviceTipoEmpleado.getListFiltered(this.filter).subscribe((data) => {
      this.model = data;
      this.resultsLength = data.total;
    });
  }

  search(): void{
    this.filter.page = 1;
    this.filter.pageSize = 30;
    this.serviceTipoEmpleado
      .getListFiltered(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
      });
  }

  getPaginatorData(event: any) {
    this.filter.page = event.pageIndex + 1;
    this.filter.pageSize = event.pageSize;
    this.serviceTipoEmpleado
      .getListFiltered(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
      });
  }

}
